import CleverTap from 'clevertap-web-sdk';
import { consoleLog } from '../services/common/utils';
export {logEvents, setUserProperty, screenRecordEvent, setNewUserProperty};

const logEvents = (eventname, obj) => {
    consoleLog("logEvents method->eventname:"+eventname+"")
    CleverTap.event.push(eventname, obj);
  };

  const screenRecordEvent = (eventname,logintype,rnuserdetails) => {

    consoleLog('screenRecordEvent- ' + eventname, {
        screen_name: eventname,
        LoginType: logintype || '',
        Status: 'Success',
        'Mobile Number': rnuserdetails?.msisdn || '',
        'Status Description': 'Success',
        'Channel':"WEBPORTAL"
      });

    CleverTap.event.push('screenview', {
      screen_name: eventname,
      LoginType: logintype || '',
      Status: 'Success',
      'Mobile Number':rnuserdetails?.msisdn || '',
      'Status Description': 'Success',
    });
  };


  const setUserProperty = ({
    email,
    name,
    ContractID,
    mobileNo,
    isdigital,
    rateplantype,
    custtype,
    language,
    voiceline,
    rnuserdetails
  }) => {
    var userRatePlanType = ''; 
    if (voiceline === true) {
      userRatePlanType = rateplantype + ' VOICE';
    } else {
      userRatePlanType = rateplantype + ' WBB';
    }
  
    consoleLog('User Prop ---', {
        'SSO Details': email || 'Partial without email',
        Email: email,
        Identity: ContractID,
        Name: name,
        'Mobile Number': mobileNo,
        isdigitalcustomer: isdigital,
        PlanType: rateplantype,
        RatePlanType: rateplantype,
        CustomerType: custtype,
        UserRatePlanType: userRatePlanType,
        'Push notification': 'yes',
        //'Smart Login': 'yes',
        ContractID: ContractID,
        Language: language,
        rnuserdetails:rnuserdetails,
        'Updated on': new Date().toISOString(),
      });



    CleverTap.onUserLogin.push({
        "Site": {
            'SSO Details': email,
            "Name": name,            // String
            "Identity": mobileNo,              // String or number
            "Email": email,         // Email address of the user
            "Phone": "+"+mobileNo,           // Phone (with the country code)
            "Gender":  (rnuserdetails?.gender || ''),                     // Can be either M or F
            "DOB": (rnuserdetails?.dob || ''),                 // Date of Birth. Date object
         // optional fields. controls whether the user will be sent email, push etc.
            "MSG-email": false,                // Disable email notifications
            "MSG-push": true,                  // Enable push notifications
            "MSG-sms": true,                   // Enable sms notifications
            "MSG-whatsapp": true,              // Enable WhatsApp notifications
            "Mobile Number": mobileNo,
              "isdigitalcustomer": isdigital,
              "PlanType": rateplantype,
              "RatePlanType": rateplantype,
              "UserRatePlanType": userRatePlanType,
              "CustomerType": custtype,
              'Push notification': 'yes',
              //'Smart Login': 'yes',
              "ContractID": ContractID,
              "Language": language,
              'Updated on': new Date().toISOString(),
              "Segment": custtype
    }
    });
  };
  
  const setNewUserProperty = (type, value) => {
      CleverTap.onUserLogin.push({
        "Site": {
          [type]: value
        }  
      });
  };
  